import {React, useState} from 'react'
import IconButton from '@mui/material/IconButton';
import EventIcon from '@mui/icons-material/Event';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';


const IconField = (props) => {
  const {
    setOpen,
    id,
    disabled,
    InputProps: {ref} = {},
    inputProps: { 'aria-label': ariaLabel} = {},
  } = props;

  return (
    <IconButton
      id={id}
      disabled = {disabled}
      ref={ref}
      aria-label={ariaLabel || 'select date'}
      onClick={() => setOpen?.((prev) => !prev)}  
    >
      <EventIcon fontSize='medium' style={{color: 'black'}}/>
    </IconButton>
  );
}

const DatePickerWrapper = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <DatePicker 
      slots={{ ...props.slots, field: IconField}}
      slotProps={{...props.slotProps, field: { setOpen }}}
      {...props}
      open={open}
      minDate={dayjs('3-8-2025')}
      maxDate={dayjs()}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}

const IconDatePicker = ({date, setDate}) => {
  const handleDateChange = (newDate) => {
    console.log('Date picker selected:', newDate ? newDate.format('YYYY-MM-DD') : 'null'); // Log the new date
    setDate(newDate);
  };

  return (
    <DatePickerWrapper
      value={date}
      onChange={handleDateChange}
    />
  );
}

export default IconDatePicker